export { default as StudyPlan } from './LazyStudyPlan';
export type { default as StudyPlanProps } from './types';
